import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { AuthUser } from '@core/models/auth-user.model';

import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthResponse } from '@core/models/auth-response.model';

@Injectable()
export class AuthService {
  constructor(private http: HttpClient) {}

  login(user: AuthUser): Observable<boolean> {
    const endPoint = 'auth/login';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .post<AuthResponse>(endPoint, user, { headers })
      .pipe(
        tap(setLocalStorage),
        map((response: AuthResponse) => {
          return response ? true : false;
        })
      );
  }
  getRole(): any {
    const token = localStorage.getItem('access_token');
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token);
    return decodedToken?.role;
  }

  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_role');
  }

  isLoggedIn(): boolean {
    const authToken = localStorage.getItem('access_token');

    return authToken ? true : false;
  }

  getToken(): string {
    return localStorage.getItem('access_token');
  }
}

function setLocalStorage(response: AuthResponse): void {
  const helper = new JwtHelperService();
  const decodedToken = helper.decodeToken(response.token);

  localStorage.setItem('access_token', response.token);
  localStorage.setItem('user_role', decodedToken.role);
}
